//@ts-check
import React, { useState } from 'react';

/** @type {React.FC<{url:string}>} */
export const ImageContainer = ({ url }) => {
  const [loaded, setLoaded] = useState(true);
  return (
    <div className="flex h-[320px] w-full md:w-[700px] md:h-[420px] lg:w-[900px] xl:w-[960px] mx-auto md:pt-6">
      <img
        src={url}
        onLoadStart={() => {
          console.debug('loading');
          setLoaded(false);
        }}
        onLoad={() => {
          console.debug('loaded');
          setLoaded(true);
        }}
        loading="lazy"
        className={`object-cover h-full w-full ${
          loaded ? '' : 'aspect-video animate-pulse bg-gray-100'
        }`}
      ></img>
    </div>
  );
};